export default __webpack_public_path__ + "static/media/about_point_two.bc71ff02.svg";